<div class="login">
  <!-- Figura de marca al fondo: cruza caminando de izquierda a derecha,
       se da la vuelta y regresa (animación CSS, sin GIF). Decorativa.
       El wrapper lleva el viaje horizontal y el giro; la imagen interna,
       el sube-baja de los pasos. -->
  <div class="login__walker" aria-hidden="true">
    <img src="assets/images/login_figure.png" alt="" class="login__figure" />
  </div>

  <div class="login__panel">
    <img src="assets/images/logo_epione_colors.png" alt="Epione" class="login__logo" />
    <h1 class="login__title">Medtronic Surgical</h1>

    @if (errorMessage()) {
      <div class="login__alert login__alert--error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage() }}</span>
      </div>
    }
    @if (successMessage()) {
      <div class="login__alert login__alert--ok">
        <mat-icon>check_circle_outline</mat-icon>
        <span>{{ successMessage() }}</span>
      </div>
    }

    <!-- ── Paso: credenciales ─────────────────────────────────────────── -->
    @if (step() === 'login') {
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Correo o teléfono</mat-label>
          <input matInput type="text" formControlName="username" autocomplete="username" />
          <mat-icon matSuffix>person_outline</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            autocomplete="current-password"
            />
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          class="login__submit"
          type="submit"
          [disabled]="loginForm.invalid || isLoading()"
          >
          @if (isLoading()) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          @if (!isLoading()) {
            <span>Iniciar sesión</span>
          }
        </button>
        <button mat-button type="button" class="login__link" (click)="goTo('forgot')">
          ¿Olvidaste tu contraseña?
        </button>
      </form>
    }

    <!-- ── Paso: contraseña nueva obligatoria ─────────────────────────── -->
    @if (step() === 'newPassword') {
      <form [formGroup]="newPasswordForm" (ngSubmit)="onConfirmNewPassword()">
        <p class="login__hint">Es tu primer acceso. Define tu nombre y una contraseña nueva.</p>
        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Nombre completo</mat-label>
          <input matInput formControlName="name" autocomplete="name" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Contraseña nueva</mat-label>
          <input
            matInput
            [type]="hideNewPassword ? 'password' : 'text'"
            formControlName="newPassword"
            autocomplete="new-password"
            />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="hideNewPassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
          (click)="hideNewPassword = !hideNewPassword">
          <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        </mat-form-field>

        <!-- Requisitos en vivo: cada uno pasa a verde con palomita al
             cumplirse. Lee la política de shared/security/password-policy.ts -->
        <app-password-strength
          [password]="newPasswordForm.get('newPassword')?.value || ''"
          [email]="loginForm.get('username')?.value || ''"
          [name]="newPasswordForm.get('name')?.value || ''">
        </app-password-strength>

        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Confirmar contraseña</mat-label>
          <input
            matInput
            [type]="hideNewConfirm ? 'password' : 'text'"
            formControlName="confirmPassword"
            autocomplete="new-password"
            />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="hideNewConfirm ? 'Mostrar contraseña' : 'Ocultar contraseña'"
          (click)="hideNewConfirm = !hideNewConfirm">
          <mat-icon>{{ hideNewConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (newPasswordForm.hasError('mismatch') && newPasswordForm.get('confirmPassword')?.touched) {<mat-error>Las contraseñas no coinciden</mat-error>}
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          class="login__submit"
          type="submit"
          [disabled]="newPasswordForm.invalid || isLoading()"
          >
          Guardar y entrar
        </button>
      </form>
    }

    <!-- ── Paso: código (MFA o correo) ────────────────────────────────── -->
    @if (step() === 'mfa' || step() === 'emailCode') {
      <form
        [formGroup]="codeForm"
        (ngSubmit)="onSendCode()"
        >
        <p class="login__hint">
          {{ step() === 'mfa' ? 'Ingresa el código de tu app de autenticación.' : 'Ingresa el código que enviamos a tu correo.' }}
        </p>
        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Código de verificación</mat-label>
          <input matInput formControlName="code" inputmode="numeric" autocomplete="one-time-code" />
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          class="login__submit"
          type="submit"
          [disabled]="codeForm.invalid || isLoading()"
          >
          Verificar
        </button>
      </form>
    }

    <!-- ── Paso: recuperar contraseña ─────────────────────────────────── -->
    @if (step() === 'forgot') {
      <form [formGroup]="forgotForm" (ngSubmit)="onForgotPassword()">
        <p class="login__hint">Te enviaremos un código para restablecer tu contraseña.</p>
        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Correo o teléfono</mat-label>
          <input matInput type="text" formControlName="username" />
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          class="login__submit"
          type="submit"
          [disabled]="forgotForm.invalid || isLoading()"
          >
          Enviar código
        </button>
        <button mat-button type="button" class="login__link" (click)="goTo('login')">Volver</button>
      </form>
    }

    <!-- ── Paso: confirmar recuperación ───────────────────────────────── -->
    @if (step() === 'forgotConfirm') {
      <form
        [formGroup]="forgotConfirmForm"
        (ngSubmit)="onConfirmForgotPassword()"
        >
        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Código recibido</mat-label>
          <input matInput formControlName="code" inputmode="numeric" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Contraseña nueva</mat-label>
          <input
            matInput
            [type]="hideForgotPassword ? 'password' : 'text'"
            formControlName="newPassword"
            autocomplete="new-password"
            />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="hideForgotPassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
          (click)="hideForgotPassword = !hideForgotPassword">
          <mat-icon>{{ hideForgotPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        </mat-form-field>

        <app-password-strength
          [password]="forgotConfirmForm.get('newPassword')?.value || ''"
          [email]="forgotForm.get('username')?.value || ''">
        </app-password-strength>

        <mat-form-field appearance="outline" class="login__field">
          <mat-label>Confirmar contraseña</mat-label>
          <input
            matInput
            [type]="hideForgotConfirm ? 'password' : 'text'"
            formControlName="confirmPassword"
            autocomplete="new-password"
            />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="hideForgotConfirm ? 'Mostrar contraseña' : 'Ocultar contraseña'"
          (click)="hideForgotConfirm = !hideForgotConfirm">
          <mat-icon>{{ hideForgotConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (forgotConfirmForm.hasError('mismatch') && forgotConfirmForm.get('confirmPassword')?.touched) {<mat-error>Las contraseñas no coinciden</mat-error>}
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          class="login__submit"
          type="submit"
          [disabled]="forgotConfirmForm.invalid || isLoading()"
          >
          Restablecer contraseña
        </button>
        <button mat-button type="button" class="login__link" (click)="goTo('login')">Volver</button>
      </form>
    }
  </div>
</div>
